import React from 'react';
import { DateTime } from 'luxon';
import { getDaySuffix } from '@util/config';

const UnScoreDrive = ({ item }) => {

    const startTime = DateTime.fromISO(item?.start_time);
    const day = startTime.day;
    const month = startTime.toFormat('MMMM');
    const year = startTime.year;
    const dayWithSuffix = day + getDaySuffix(day);

    const experiencePoints = item?.experience_points / 10;
    const distance = item?.distance / 1000;
    const distanceRoundNumber = Math.round(distance * 100) / 100;
    const experiencePointsRoundNumber = Math.round(experiencePoints * 100) / 100;
    const qualifiedMilesRoundNumber = Math.round(item?.qualified_miles * 100) / 100;

    const startDateDuration = new Date(item?.start_time);
    const endDateDuration = new Date(item?.end_time);
    const differenceDurationMs = endDateDuration - startDateDuration;
    const differenceDurationSeconds = Math.floor(differenceDurationMs / 1000);
    const minutes = Math.floor(differenceDurationSeconds / 60);
    const seconds = differenceDurationSeconds % 60;
    const formattedSeconds = seconds < 10 ? `0${seconds}` : seconds;

    return (
        <tr className='w-full flex justify-between items-center'>
            <td className='w-[40%] flex flex-col justify-center items-start'>
                <div className='flex flex-col md:flex-row md:gap-4 text-[#282828] text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>
                    <span>{item.botName} Drive</span>
                    <div>
                      {item.username &&
                          <span className='flex justify-center items-center gap-[4px] text-[#008735]'>
                              <svg className='w-[8px] h-[8px]' viewBox='0 0 100 100'>
                                  <circle cx='50' cy='50' r='50' fill='#008735' />
                              </svg>
                              {item.username}
                          </span>
                      }
                    </div>
                </div>
                <div className='flex items-center gap-[4px] text-[#727272] text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'> Start: {`${dayWithSuffix} ${month} ${year}`} - Duration: {minutes > 0 ? `${minutes}:${formattedSeconds} min` : `${formattedSeconds} sec`}</div>
            </td>
            <td className='w-[60%] flex justify-end items-center'>
                <div className='w-[33%] text-[#727272] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{distanceRoundNumber ? distanceRoundNumber : '---'}</div>
                <div className='w-[33%] text-[#0A6AF3] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{experiencePointsRoundNumber ? experiencePointsRoundNumber : '---'}</div>
                <div className='w-[33%] text-[#0A6AF3] text-center text-[13px] sm:text-[16px] not-italic font-medium leading-[22px] tracking-[-0.32px]'>{qualifiedMilesRoundNumber ? qualifiedMilesRoundNumber : '---'}</div>
            </td>
        </tr>
    )
}

export default UnScoreDrive
